import type { TokenRenewal } from '@luminovo/auth';
import * as Sentry from '@sentry/react';

/** Logs a renewal made while the pages held a token (SOU-5207); the auth package skips cached same-token answers. */
export function reportTokenRenewal({ outcome, error, heldTokenAgeSeconds, heldTokenExpired }: TokenRenewal): void {
    // Best effort: telemetry must not affect the renewal.
    try {
        const attributes = {
            outcome,
            ...(error === undefined ? {} : { error }),
            ...(heldTokenAgeSeconds === undefined ? {} : { held_token_age_s: heldTokenAgeSeconds }),
            ...(heldTokenExpired === undefined ? {} : { held_token_expired: heldTokenExpired }),
        };
        if (outcome === 'failed') {
            Sentry.logger.warn('auth.token_renewal', attributes);
        } else {
            Sentry.logger.info('auth.token_renewal', attributes);
        }
    } catch {}
}
